import { createBrowserHistory } from 'history';
/**
 * Please, make sure to use history object only for redux LOGOUT.
 * For any ther navigation purpouse use useNavigate hook from react-router-dom.
 */
const history = createBrowserHistory();
export default history;
